import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Checkbox } from "../../ui/checkbox";
import React from "react";

interface DownloadReportDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
    includeAlertJson: boolean;
    setIncludeAlertJson: (val: boolean) => void;
    title?: string;
    subtitle?: string;
}

const DownloadReportDialog: React.FC<DownloadReportDialogProps> = ({
    open,
    onOpenChange,
    onConfirm,
    onCancel,
    loading = false,
    includeAlertJson,
    setIncludeAlertJson,
    title,
    subtitle
}) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md" data-testid="download-report-dialog">
                <DialogHeader className="space-y-4">
                    <DialogTitle className="text-lg font-semibold text-slate-800 dark:text-slate-100">
                        Download Report
                    </DialogTitle>
                    <DialogDescription className="leading-relaxed text-slate-600 dark:text-slate-400">
                        {title || "Do you want to download the report?"}
                        <div className="flex items-center gap-2 mt-4">
                            <Checkbox
                                id="include-alert-json"
                                checked={includeAlertJson}
                                onCheckedChange={val => setIncludeAlertJson(val === true)}
                            />
                            <label htmlFor="include-alert-json" className="text-sm select-none cursor-pointer">{subtitle}</label>
                        </div>
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2 mt-6">
                    <Button
                        variant="outline"
                        onClick={onCancel}
                        disabled={loading}
                        data-testid="button-cancel-download-report"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onConfirm}
                        disabled={loading}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                        data-testid="button-confirm-download-report"
                    >
                        {loading ? "Processing..." : "Download Report"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DownloadReportDialog;
